<script setup lang="ts">
const { data: header } = await useAsyncData('component-header', () =>
  queryCollection('componentHeader').first(),
)

const route = useRoute()
</script>

<template>
  <header class="sticky top-0 z-40 bg-brand-chalk/95 backdrop-blur border-b border-brand-line overflow-hidden">
    <SfgSurfaceTexture variant="chalk"/>
    <div class="relative z-10 mx-auto flex max-w-7xl items-center justify-between gap-4 md:gap-6 px-4 py-3 sm:py-4 sm:px-8 md:py-5">
      <NuxtLink
        aria-label="Signal Fire Games home"
        to="/"
        class="shrink-0"
      >
        <!--
          Wrap each wordmark in its own visibility-controlled div
          rather than passing `hidden` / `block` down to SfgWordmark.
          The wordmark's root element already carries an `inline-flex`
          display utility, which wins over a merged `block` utility
          due to Tailwind's source ordering, so passing visibility
          classes through the component caused both variants to
          render at XS. Wrapping keeps the display control on a
          separate element and resolves the collision cleanly.
        -->
        <div class="block sm:hidden">
          <SfgWordmark
            variant="compact-stack"
            :label="header?.wordmark.label"
          />
        </div>
        <div class="hidden sm:block">
          <SfgWordmark
            variant="compact-red"
            :label="header?.wordmark.label"
            :tagline="header?.wordmark.tagline"
            :with-tagline="true"
          />
        </div>
      </NuxtLink>

      <nav v-if="header?.nav?.length" class="hidden md:flex items-center gap-6">
        <NuxtLink
          v-for="item in header.nav"
          :key="item.to"
          :to="item.to"
          class="font-display uppercase text-[13px] tracking-widest text-brand-ink hover:text-brand-red transition-colors"
          :class="route.path.startsWith(item.to) ? 'text-brand-red' : ''"
        >
          {{ item.label }}
        </NuxtLink>
      </nav>

      <SfgButton
        v-if="header?.cta"
        :to="header.cta.to"
        size="sm"
        variant="primary"
        class="shrink-0"
      >
        {{ header.cta.label }}
      </SfgButton>
    </div>
  </header>
</template>
